import type { OpencodeToolPart } from "schemas/generated/agentTools/opencode";

import { parseJsonOrNull } from "replo-utils/lib/json";

import { getToolInputString, parseRecordOrNull, quotedText } from "../shared";

export type DetailPart = {
  label: string;
  value: string | null;
};

export const reploAssetsIntegrationKey = "replo-assets";

export function getToolPartOutputJson({
  toolPart,
}: {
  toolPart: OpencodeToolPart;
}) {
  if (!("output" in toolPart.state)) {
    return null;
  }

  const parsedOutput = parseJsonOrNull(toolPart.state.output);
  const outputRecord = parseRecordOrNull(parsedOutput);
  const content = Array.isArray(parsedOutput)
    ? parsedOutput
    : outputRecord?.content;
  if (!Array.isArray(content)) {
    return parsedOutput;
  }

  for (const contentItem of content) {
    const contentRecord = parseRecordOrNull(contentItem);
    if (
      contentRecord?.type === "text" &&
      typeof contentRecord.text === "string"
    ) {
      return parseJsonOrNull(contentRecord.text) ?? parsedOutput;
    }
  }

  return parsedOutput;
}

export function getToolPartOutputRecord({
  toolPart,
}: {
  toolPart: OpencodeToolPart;
}) {
  return parseRecordOrNull(getToolPartOutputJson({ toolPart }));
}

export function naturalDetail({ parts }: { parts: readonly DetailPart[] }) {
  const detail = parts
    .flatMap((part) => {
      return part.value
        ? [`${part.label} ${quotedText({ value: part.value })}`]
        : [];
    })
    .join(", ");

  return detail.length > 0 ? detail : null;
}

export function getInputDetailPart({
  label,
  properties,
  toolPart,
}: {
  label: string;
  properties: readonly string[];
  toolPart: OpencodeToolPart;
}): DetailPart {
  return {
    label,
    value: getToolInputString({ properties, toolPart }),
  };
}
